import AddIftag from './AddIfTag';

const ifTag = {
  id: 'if',
  AddTag: AddIftag
};

export default ifTag;
